function boostResponsiveSlider() {
  const widget = document.querySelector('#boost-sd-widget-productpage-011210');
  if (!widget) return;

  const slider = widget.querySelector('.boost-sd__slider');
  const products = widget.querySelectorAll('.boost-sd__product-item');
  const buttons = widget.querySelectorAll('.boost-sd__slider-button');

  if (!slider || !products.length) return;

  const containerWidth = slider.clientWidth;

  let totalWidth = 0;
  products.forEach(p => {
    totalWidth += p.getBoundingClientRect().width;
  });

  const shouldSlide = totalWidth > containerWidth + 5;

  if (shouldSlide) {
    slider.classList.remove('boost-no-slider');
    buttons.forEach(b => b.style.display = "flex");
  } else {
    slider.classList.add('boost-no-slider');
    buttons.forEach(b => b.style.display = "none");
  }
}

/* Wait for Boost + Slick + images */
function waitForBoost() {
  const products = document.querySelectorAll('.boost-sd__product-item');
  if (products.length) {
    setTimeout(boostResponsiveSlider, 400);
    window.addEventListener('load', boostResponsiveSlider);
    window.addEventListener('resize', boostResponsiveSlider);
  } else {
    setTimeout(waitForBoost, 200);
  }
}

waitForBoost();
